import React from 'react'
import { useReferenceSheet } from '../ReferenceSheetProvider'
import { EditorHeading } from '../../ResumeBuilder/Editor/common'
import { EditorItemField, EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const BasicsEditor = () => {
  const { t } = useTranslation('BasicEditor')
  const { referenceSheetDocument: { basics } = {} } = useReferenceSheet()
  const handleLinkedInProfileUpdate = (item, value) => {
    const updatedProfiles = item.profiles?.map((profile) =>
      profile.network?.toLowerCase() === 'linkedin'
        ? { ...profile, url: value }
        : profile,
    ) || [{ network: 'LinkedIn', url: value }]
    return {
      ...item,
      profiles: updatedProfiles,
    }
  }

  const getLinkedInUrl = (item) =>
    item?.profiles?.find(
      (profile) => profile.network?.toLowerCase() === 'linkedin',
    )?.url || ''

  return (
    <EditorItemProvider sectionName="basics" item={basics}>
      <div>
        <EditorHeading>{t('personal_details')}</EditorHeading>
        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
          <EditorItemField
            containerClassName="md:col-span-2"
            label={t('job_title')}
            fieldName="label"
          />
          <EditorItemField
            containerClassName="md:col-span-2"
            label={t('full_name')}
            fieldName="name"
          />
          <EditorItemField label={t('phone')} fieldName="phone" />
          <EditorItemField label={t('email')} fieldName="email" />
          <EditorItemField
            label={t('address')}
            fieldName="location"
            childField="address"
          />
          <EditorItemField
            label={t('city')}
            fieldName="location"
            childField="city"
          />
          <EditorItemField
            label={t('region')}
            fieldName="location"
            childField="region"
          />
          <EditorItemField
            label={t('postal_code')}
            fieldName="location"
            childField="postalCode"
          />
          <EditorItemField label={t('website')} fieldName="url" />
          <EditorItemField
            label={t('linkedin')}
            fieldName="profiles"
            getItemValue={getLinkedInUrl}
            handleItemUpdate={handleLinkedInProfileUpdate}
          />
        </div>
      </div>
    </EditorItemProvider>
  )
}
export default BasicsEditor
